import { ReactNode } from 'react';

interface StatCardProps {
  title: string;
  onClick?: () => void;
  icon?: ReactNode;
}

/**
 * StatCard component - Reusable card component for tutorial cards and stats
 * 
 * Features:
 * - Clickable card with hover states
 * - Optional icon support
 * - Responsive: cards stack on mobile, side-by-side on desktop
 * - Accessible: keyboard navigation support
 */
export const StatCard = ({ title, onClick, icon }: StatCardProps) => {
  const Component = onClick ? 'button' : 'div';
  const baseClasses = `
    p-6 rounded-lg border border-border bg-background
    transition-all duration-200
    ${onClick
      ? 'cursor-pointer hover:border-primary hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2'
      : ''
    }
  `;

  return (
    <Component
      onClick={onClick}
      className={baseClasses}
      type={onClick ? 'button' : undefined}
    >
      <div className="flex items-center gap-4">
        {icon && (
          <div className="flex-shrink-0 text-primary">
            {icon}
          </div>
        )}
        <h3 className="text-h4 font-medium text-text-primary">
          {title}
        </h3>
      </div>
    </Component>
  );
};

